import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "../../GenericTableResponse";

export class ContractorServiceTypeTradeTerm {
  @Expose()
  @IsNumber()
  id!: number;

  @Expose()
  @IsString()
  documentType!: string;

  @Expose()
  @IsString()
  name!: string;

  @Expose()
  @IsString()
  vat!: string;

  @Expose()
  @IsBoolean()
  hasTradeTerm!: boolean;

  @Expose()
  @IsBoolean()
  isLocked!: boolean;
}

export class ContractorServiceTypeTradeTermResponse extends GenericTableResponse<ContractorServiceTypeTradeTerm> {
  @Expose()
  @IsArray()
  @Type(() => ContractorServiceTypeTradeTerm)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<ContractorServiceTypeTradeTerm>;
}
